import React from 'react';

import { DialogActions, DialogContent, Typography } from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';

import StdDialog from 'components/Dialogs/StdDialog';
import QButton from 'components/QButton';
import RuleSummaryRow from './RuleSummaryRow';

import { useStateContext } from 'app-components/flux/transaction-rules/transactionRulesFormState';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { ResolutionTypeEnum } from 'app-components/flux/transaction-rules/transactionRulesTypes';

import useStyles from './styles';

type DuplicateDialogPros = {
  onAction: (action: ResolutionTypeEnum) => void;
  originalRule: TransactionRuleType;
};

export const RuleDuplciateDialog = ({ onAction, originalRule }: DuplicateDialogPros) => {
  const { classes } = useStyles();
  const { state } = useStateContext();
  const { duplicateId } = state;

  return (
    <StdDialog
      onClose={() => onAction(ResolutionTypeEnum.CLOSE)}
      open={!!duplicateId}
      showCloseButton
      size='md'
      title='Rule conflict detected'
    >
      <DialogContent sx={{ width: 516, margin: 'auto', px: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant='bodyMedium'>
          There&apos;s a conflict due to an existing rule that modifies the same transactions.
        </Typography>
        <Typography variant='bodyRegular'>
          You can choose to to edit the existing rule and discard your work, or continue with your new rule: this will
          delete the existing below.
        </Typography>
        <Typography variant='bodyMedium'>Existing rule:</Typography>
        <RuleSummaryRow rule={originalRule} veritcalWithLabel />
      </DialogContent>
      <DialogActions sx={{ border: 'none' }}>
        <QButton
          id='edit-exiting-rule'
          className={classes.button}
          variant='outlined'
          onClick={() => onAction(ResolutionTypeEnum.EDIT)}
          startIcon={<EditIcon />}
        >
          <Typography variant='button'>Edit Existing</Typography>
        </QButton>
        <QButton
          id='continue-with-new-rule'
          className={classes.button}
          variant='contained'
          onClick={() => onAction(ResolutionTypeEnum.REPLACE)}
          endIcon={<ArrowForwardIcon />}
        >
          <Typography variant='button'>Replace With New Rule</Typography>
        </QButton>
      </DialogActions>
    </StdDialog>
  );
};
